/* unplugin-vue-components disabled */import script from "./indexProjectItemRight.vue?vue&type=script&setup=true&lang=js"
export * from "./indexProjectItemRight.vue?vue&type=script&setup=true&lang=js"

import "./indexProjectItemRight.vue?vue&type=style&index=0&id=367d43e6&scoped=true&lang=less"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-367d43e6"]])

export default __exports__